import withHandlers from 'recompose/withHandlers';
import withState from 'recompose/withState';
import withProps from 'recompose/withProps';
import compose from 'recompose/compose';
import ChairRentalModal from '../components/ChairRentalModal';
import chairRentalForm from './ChairRentalForm';
import confirmModal from '../../../../common/confirmModal';

export default compose(
  chairRentalForm,
  withState('activeTab', 'setActiveTab', 'Details'),
  withHandlers({
    isTabWithForm: props => () => props.activeTab === 'Details',
  }),
  withProps(ownProps => ({
    enabled: ownProps.isTabWithForm() ? ownProps.enabled : ownProps.chairRental.enabled,
  })),
  withHandlers({
    toggleEnabled: props => () => {
      if (!props.isTabWithForm()) {
        return false;
      }
      return props.change('enabled', !props.enabled);
    },
    closeModal: props => () => {
      if (!props.dirty) {
        return props.close();
      }

      return confirmModal({
        title: 'Unsaved changes',
        message: 'Would you like to save the changes before closing?',
        type: 'yesno',
        confirmButtonText: 'Yes',
        negativeButtonText: 'No',
      },
        async () => {
          await props.submitForm();
          return props.close();
        },
        () => props.close()
      );
    },
  })
)(ChairRentalModal);
